export default "__VITE_ASSET__2c99f5d4__"